module.exports = "https://static.wmbcdn.com/uniweb/images/2f5c0864fef061297576dcbc8a7a0d72.svg";